export default __webpack_public_path__ + "static/media/capitual-logo.5f4b97d4.svg";